export default __webpack_public_path__ + "static/media/man.2a78a85e.jpg";